const PGAdapter = require('../../common/pg-adapter')

const LOCATION_OPTIONS_TABLE_NAME = 'avocado.data_location_options'
const LOCATION_OPTIONS_COLUMNS = [
  'location_id',
  'has_pcr',
  'facility_id',
  'ward',
  'tracks_partner_balances',
  'warehouse_code',
  'supplies_cold_chain',
  'alias',
  'batch_tracking_services',
  'created_at',
  'updated_at'
]

class LocationOptionsPgAdapter extends PGAdapter {
  constructor ({pgConnection, logger, username}) {
    super(pgConnection,
      LOCATION_OPTIONS_TABLE_NAME,
      username,
      LOCATION_OPTIONS_COLUMNS,
      'location_id',
      {},
      logger
    )
  }

  async upsert (uuid, doc) {
    const toBooleanOrNull = (value) => {
      if (value === null || value === undefined || value === '') {
        return null
      }
      return Boolean(value)
    }

    const locationOptions = {
      location_id: uuid,
      has_pcr: toBooleanOrNull(doc.additionalData && doc.additionalData.hasPcr),
      facility_id: (doc.additionalData && doc.additionalData.facilityId) || null,
      ward: (doc.additionalData && doc.additionalData.ward) || null,
      tracks_partner_balances: toBooleanOrNull(doc.additionalData && doc.additionalData.tracksPartnerBalances),
      warehouse_code: (doc.additionalData && doc.additionalData.warehouseCode) || null,
      supplies_cold_chain: toBooleanOrNull(doc.additionalData && doc.additionalData.suppliesColdChain),
      alias: doc.alias,
      batch_tracking_services: doc.batchTrackingServices,
      created_at: doc.createdAt,
      updated_at: new Date()
    }
    return super.upsert(locationOptions)
  }
}

module.exports = LocationOptionsPgAdapter
